import { type Route } from '@/types/route'

import { getFirstPossibleRoute } from '../utils/getFirstPossibleRoute'

export const infoboardsTabRoutes = [
  {
    path: 'staff-boards',
    name: 'infoboards-staff-boards' as const,
    component: () => import('@/views/Infoboards/StaffBoards/StaffBoards.vue'),
    meta: {
      title: 'Boards',
      icon: 'layout',
      tab: 'administration',
      permissions: ['infoboards.view_board']
    }
  },
  {
    path: 'drafts',
    name: 'infoboards-drafts' as const,
    component: () => import('@/views/Infoboards/Drafts/Drafts.vue'),
    meta: {
      title: 'Drafts',
      icon: 'edit',
      featureFlag: 'FEATURE_NEVERENDING_FEED',
      tab: 'administration',
      permissions: ['infoboards.view_board']
    }
  },
  {
    path: 'students-boards',
    name: 'infoboards-student-board' as const,
    component: () =>
      import('@/views/Infoboards/StudentsBoards/StudentsBoards.vue'),
    meta: {
      title: "Students' posts",
      tab: 'administration',
      icon: 'carry-out',
      permissions: ['infoboards.view_board']
    }
  },
  {
    path: 'alerts-and-notice',
    name: 'infoboards-alert-and-notice' as const,
    component: () => import('@/views/Infoboards/Messages/Messages.vue'),
    meta: {
      title: 'Alerts & notice',
      tab: 'administration',
      icon: 'safety',
      permissions: ['infoboards.view_board', 'infoboards.view_message']
    }
  },
  {
    path: 'schedule',
    name: 'infoboards-schedule' as const,
    component: () => import('@/views/Infoboards/Schedule/Schedule.vue'),
    meta: {
      title: 'Schedule',
      tab: 'administration',
      disabledWithFeatureFlag: 'FEATURE_NEVERENDING_FEED',
      icon: 'calendar',
      permissions: ['infoboards.view_board', 'infoboards.view_boardschedule']
    }
  },
  {
    path: 'settings',
    name: 'infoboards-settings' as const,
    component: () => import('@/views/Infoboards/Settings/Settings.vue'),
    meta: {
      title: 'Infoboards settings',
      icon: 'setting',
      tab: 'administration',
      permissions: [
        'infoboards.view_board',
        'infoboards.view_infoboardssettings'
      ]
    }
  }
] satisfies Route[]

export const staffBoardsChildrenRoutes = [
  {
    path: 'create',
    name: 'infoboards-staff-board-add' as const,
    component: () =>
      import(
        '@/views/Infoboards/StaffBoards/StaffBoardsForm/StaffBoardsForm.vue'
      ),
    meta: {
      title: 'Create Board',
      tab: 'administration',
      permissions: ['infoboards.add_board']
    }
  },
  {
    path: ':id',
    name: 'infoboards-staff-board-details' as const,
    component: () =>
      import(
        '@/views/Infoboards/StaffBoards/StaffBoardsForm/StaffBoardsForm.vue'
      ),
    meta: {
      title: 'Board Details',
      tab: 'administration',
      permissions: ['infoboards.view_board']
    }
  }
] satisfies Route[]

export const studentsBoardsChildrenRoutes = [
  {
    path: 'announcements/:itemId',
    name: 'student-board-announcement-details' as const,
    component: () =>
      import(
        '@/views/Infoboards/StudentsBoards/PostDetails/StudentAnnouncementDetails.vue'
      ),
    meta: {
      title: "Student's announcement details",
      tab: 'administration',
      permissions: ['students_announcement_widget.view_studentannouncement']
    }
  },
  {
    path: 'pics/:itemId',
    name: 'student-board-pic-details' as const,
    component: () =>
      import(
        '@/views/Infoboards/StudentsBoards/PostDetails/StudentPicDetails.vue'
      ),
    meta: {
      title: "Student's pic details",
      tab: 'administration',
      permissions: ['students_pic_widget.view_studentpic']
    }
  },
  {
    path: 'mystery-links/:itemId',
    name: 'student-board-mystery-link-details' as const,
    component: () =>
      import(
        '@/views/Infoboards/StudentsBoards/PostDetails/StudentMysteryLinkDetails.vue'
      ),
    meta: {
      title: "Student's mystery link details",
      tab: 'administration',
      permissions: ['mystery_link_widget.view_studentmysterylink']
    }
  }
] satisfies Route[]

export const infoboardsNotTabRoutes = [
  {
    path: '',
    name: 'infoboards-tab' as const,
    component: () => import('@/components/base/BaseLayout.vue'),
    props: {
      routes: infoboardsTabRoutes
    },
    meta: {
      title: 'Infoboards',
      tab: 'administration'
    },
    redirect: () => getFirstPossibleRoute(infoboardsTabRoutes),
    children: infoboardsTabRoutes
  },
  {
    path: 'staff-boards',
    name: 'infoboards-student-boards' as const,
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      title: 'Staff boards',
      tab: 'administration'
    },
    redirect: () => getFirstPossibleRoute(staffBoardsChildrenRoutes),
    children: staffBoardsChildrenRoutes
  },
  {
    path: 'students-boards',
    name: 'infoboards-students-boards' as const,
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      title: 'Students boards',
      tab: 'administration'
    },
    redirect: () => getFirstPossibleRoute(studentsBoardsChildrenRoutes),
    children: studentsBoardsChildrenRoutes
  }
] satisfies Route[]

export const infoboardsRoutes = [
  {
    path: 'infoboards',
    name: 'infoboards',
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      title: 'Infoboards',
      tab: 'administration',
      icon: 'fund',
      permissions: ['infoboards.view_board']
    },
    redirect: () => getFirstPossibleRoute(infoboardsNotTabRoutes),
    children: infoboardsNotTabRoutes
  }
] satisfies Route[]
